import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddTermsMutationVariables = Types.Exact<{
  input: Types.AddTermsInput;
}>;


export type AddTermsMutation = { __typename?: 'Mutation', addTerms: { __typename?: 'TermsPayload', terms?: { __typename?: 'TermsStateData', id: string, tenantId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateTermsMutationVariables = Types.Exact<{
  input: Types.UpdateTermsInput;
}>;


export type UpdateTermsMutation = { __typename?: 'Mutation', updateTerms: { __typename?: 'TermsPayload', terms?: { __typename?: 'TermsStateData', id: string, tenantId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateTermsMutationVariables = Types.Exact<{
  termsId: Types.Scalars['String']['input'];
}>;


export type ActivateTermsMutation = { __typename?: 'Mutation', activateTerms: { __typename?: 'TermsPayload', terms?: { __typename?: 'TermsStateData', id: string, tenantId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateTermsMutationVariables = Types.Exact<{
  termsId: Types.Scalars['String']['input'];
}>;


export type DeactivateTermsMutation = { __typename?: 'Mutation', deactivateTerms: { __typename?: 'TermsPayload', terms?: { __typename?: 'TermsStateData', id: string, tenantId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetDefaultTermsMutationVariables = Types.Exact<{
  termsId: Types.Scalars['String']['input'];
}>;


export type SetDefaultTermsMutation = { __typename?: 'Mutation', setDefaultTerms: { __typename?: 'TermsPayload', terms?: { __typename?: 'TermsStateData', id: string, tenantId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UnsetDefaultTermsMutationVariables = Types.Exact<{
  termsId: Types.Scalars['String']['input'];
}>;


export type UnsetDefaultTermsMutation = { __typename?: 'Mutation', unsetDefaultTerms: { __typename?: 'TermsPayload', terms?: { __typename?: 'TermsStateData', id: string, tenantId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteTermsMutationVariables = Types.Exact<{
  termsId: Types.Scalars['String']['input'];
}>;


export type DeleteTermsMutation = { __typename?: 'Mutation', deleteTerms: { __typename?: 'TermsPayload', terms?: { __typename?: 'TermsStateData', id: string, tenantId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CombineTermsMutationVariables = Types.Exact<{
  input: Types.CombineTermsInput;
}>;


export type CombineTermsMutation = { __typename?: 'Mutation', combineTerms: { __typename?: 'CombineTermsPayload', survivorId?: string | null, loserId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RevertTermsCombineMutationVariables = Types.Exact<{
  input: Types.RevertTermsCombineInput;
}>;


export type RevertTermsCombineMutation = { __typename?: 'Mutation', revertTermsCombine: { __typename?: 'RevertTermsCombinePayload', survivorId?: string | null, loserId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AddTermsDocument = new TypedDocumentString(`
    mutation AddTerms($input: AddTermsInput!) {
  addTerms(input: $input) {
    terms {
      ...TermsDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TermsDetails on TermsStateData {
  id
  tenantId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
}`);
export const UpdateTermsDocument = new TypedDocumentString(`
    mutation UpdateTerms($input: UpdateTermsInput!) {
  updateTerms(input: $input) {
    terms {
      ...TermsDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TermsDetails on TermsStateData {
  id
  tenantId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
}`);
export const ActivateTermsDocument = new TypedDocumentString(`
    mutation ActivateTerms($termsId: String!) {
  activateTerms(termsId: $termsId) {
    terms {
      ...TermsDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TermsDetails on TermsStateData {
  id
  tenantId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
}`);
export const DeactivateTermsDocument = new TypedDocumentString(`
    mutation DeactivateTerms($termsId: String!) {
  deactivateTerms(termsId: $termsId) {
    terms {
      ...TermsDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TermsDetails on TermsStateData {
  id
  tenantId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
}`);
export const SetDefaultTermsDocument = new TypedDocumentString(`
    mutation SetDefaultTerms($termsId: String!) {
  setDefaultTerms(termsId: $termsId) {
    terms {
      ...TermsDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TermsDetails on TermsStateData {
  id
  tenantId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
}`);
export const UnsetDefaultTermsDocument = new TypedDocumentString(`
    mutation UnsetDefaultTerms($termsId: String!) {
  unsetDefaultTerms(termsId: $termsId) {
    terms {
      ...TermsDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TermsDetails on TermsStateData {
  id
  tenantId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
}`);
export const DeleteTermsDocument = new TypedDocumentString(`
    mutation DeleteTerms($termsId: String!) {
  deleteTerms(termsId: $termsId) {
    terms {
      ...TermsDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TermsDetails on TermsStateData {
  id
  tenantId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
}`);
export const CombineTermsDocument = new TypedDocumentString(`
    mutation CombineTerms($input: CombineTermsInput!) {
  combineTerms(input: $input) {
    survivorId
    loserId
    errors {
      code
      message
    }
  }
}
    `);
export const RevertTermsCombineDocument = new TypedDocumentString(`
    mutation RevertTermsCombine($input: RevertTermsCombineInput!) {
  revertTermsCombine(input: $input) {
    survivorId
    loserId
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddTerms: build.mutation<AddTermsMutation, AddTermsMutationVariables>({
      query: (variables) => ({ document: AddTermsDocument, variables })
    }),
    UpdateTerms: build.mutation<UpdateTermsMutation, UpdateTermsMutationVariables>({
      query: (variables) => ({ document: UpdateTermsDocument, variables })
    }),
    ActivateTerms: build.mutation<ActivateTermsMutation, ActivateTermsMutationVariables>({
      query: (variables) => ({ document: ActivateTermsDocument, variables })
    }),
    DeactivateTerms: build.mutation<DeactivateTermsMutation, DeactivateTermsMutationVariables>({
      query: (variables) => ({ document: DeactivateTermsDocument, variables })
    }),
    SetDefaultTerms: build.mutation<SetDefaultTermsMutation, SetDefaultTermsMutationVariables>({
      query: (variables) => ({ document: SetDefaultTermsDocument, variables })
    }),
    UnsetDefaultTerms: build.mutation<UnsetDefaultTermsMutation, UnsetDefaultTermsMutationVariables>({
      query: (variables) => ({ document: UnsetDefaultTermsDocument, variables })
    }),
    DeleteTerms: build.mutation<DeleteTermsMutation, DeleteTermsMutationVariables>({
      query: (variables) => ({ document: DeleteTermsDocument, variables })
    }),
    CombineTerms: build.mutation<CombineTermsMutation, CombineTermsMutationVariables>({
      query: (variables) => ({ document: CombineTermsDocument, variables })
    }),
    RevertTermsCombine: build.mutation<RevertTermsCombineMutation, RevertTermsCombineMutationVariables>({
      query: (variables) => ({ document: RevertTermsCombineDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddTermsMutation, useUpdateTermsMutation, useActivateTermsMutation, useDeactivateTermsMutation, useSetDefaultTermsMutation, useUnsetDefaultTermsMutation, useDeleteTermsMutation, useCombineTermsMutation, useRevertTermsCombineMutation } = injectedRtkApi;
